var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FF4977"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0929 18.4145C15.5062 18.5878 14.8129 18.6678 13.9996 18.6678H9.99958C9.18625 18.6678 8.49292 18.5878 7.90625 18.4145C8.05292 16.6811 9.83292 15.3145 11.9996 15.3145C14.1662 15.3145 15.9462 16.6811 16.0929 18.4145Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 5.33398H9.9987C6.66536 5.33398 5.33203 6.66732 5.33203 10.0007V14.0007C5.33203 16.5207 6.09203 17.9006 7.90536 18.414C8.05203 16.6806 9.83203 15.314 11.9987 15.314C14.1654 15.314 15.9454 16.6806 16.092 18.414C17.9054 17.9006 18.6654 16.5207 18.6654 14.0007V10.0007C18.6654 6.66732 17.332 5.33398 13.9987 5.33398ZM11.9987 13.4473C10.6787 13.4473 9.61203 12.374 9.61203 11.054C9.61203 9.734 10.6787 8.66732 11.9987 8.66732C13.3187 8.66732 14.3854 9.734 14.3854 11.054C14.3854 12.374 13.3187 13.4473 11.9987 13.4473Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3866 11.0527C14.3866 12.3727 13.3199 13.446 11.9999 13.446C10.6799 13.446 9.61328 12.3727 9.61328 11.0527C9.61328 9.73269 10.6799 8.66602 11.9999 8.66602C13.3199 8.66602 14.3866 9.73269 14.3866 11.0527Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.95bb20a8c4244d092a98baf19ae544f7.svg";
export { ForwardRef as ReactComponent };